import { BaseModelPagedArray } from "@eview/core/base/base-model";
import { Post } from "@eview/core/domain/post/post";

export interface LinkedPostsState {
  linkedPosts: BaseModelPagedArray<Post>;
}

export const initialLinkedPostsState: LinkedPostsState = {
  linkedPosts: null
};
